import {
  CAPABILITIES,
  DOMAIN_STACK_MAP,
  DOMAINS,
  STACK_CAPABILITIES_MAP,
  STACKS,
} from '../types/domain.js';

export const SUPPORTED_DOMAINS = DOMAINS;
export const SUPPORTED_STACKS = STACKS;
export const SUPPORTED_CAPABILITIES = CAPABILITIES;
export { DOMAIN_STACK_MAP, STACK_CAPABILITIES_MAP };
